import React from 'react';
import styled from '@emotion/styled';
// --- external imports ------

import downBtnProjection from '../../../assets/images/baseAssets/newspaper/down-btn.png';
import Asset from '../BaseAssets';
// --- internal imports ------

function NewspaperSort() {
	return (
		<>
			<NewspaperText
				x={216}
				y={176}
				projection={{
					width: 107,
					height: 28
				}}
				fontSize={23}
			>
				SORT BY
			</NewspaperText>
			<Asset.Button
				x={335}
				y={184}
				projection={downBtnProjection}
			/>
			<NewspaperText
				x={430}
				y={176}
				projection={{
					width: 134,
					height: 28
				}}
				fontSize={23}
			>
				FILTER BY
			</NewspaperText>
			<Asset.Button
				x={576}
				y={184}
				projection={downBtnProjection}
			/>
		</>
	);
}

const NewspaperText = styled(Asset.Text)`
	font-family: "KG Corner of the Sky";
	text-align: center;
	color: #1f261f;
	line-height: 1.22em;
`;

export default NewspaperSort;
